import React, { MouseEvent } from "react";
import { makeStyles, Theme } from "@material-ui/core";
import { ViImagePartDamage, ViDamageType } from "../models";

const useStyle = makeStyles((theme: Theme) => ({
  polygon: ({
    damageType,
    highlighted = false,
    isFilterActive = false,
  }: {
    damageType: ViDamageType;
    highlighted?: boolean;
    isFilterActive?: boolean;
  }) => ({
    cursor: "pointer",
    fill: "transparent",
    stroke: theme.damageTypes[damageType],
    opacity:
      isFilterActive && highlighted === false ? 0.382 : highlighted === true ? 1 : 0.9,
    strokeWidth: `${highlighted === false ? 1.4 : 2}px`,
    ".flipping &": {
      pointerEvents: "none",
    },
  }),
}));

const Contour = ({
  damage,
  dims,
  highlighted,
  isFilterActive,
  handleHover,
}: {
  damage: ViImagePartDamage;
  dims: { w: number; h: number };
  highlighted: boolean;
  isFilterActive: boolean;
  handleHover: (e: MouseEvent) => void;
}) => {
  const classes = useStyle({
    damageType: damage.imageDamage.type,
    highlighted,
    isFilterActive,
  });

  return (
    <polygon
      vectorEffect="non-scaling-stroke"
      id={damage.id}
      className={classes.polygon}
      onMouseMove={handleHover}
      onMouseLeave={handleHover}
      points={damage.imageDamage.contour
        .map(([x, y]) => [x * dims.w, y * dims.h].join(","))
        .join(" ")}
    />
  );
};

export default React.memo(Contour);
